import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { User } from '@freelancer/datastore/collections';
import { LinkColor, LinkUnderline } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';
import {
  ResponsiveColumnPlacement,
  TableColumnPaddingSize,
  TableMobileStyle,
  TablePaginationPosition,
} from '@freelancer/ui/table';
import { FontType, FontWeight } from '@freelancer/ui/text';
import { AvatarSize } from '@freelancer/ui/user-avatar';
import { isDefined, toNumber } from '@freelancer/utils';
import * as Rx from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-payment-share-add-member-table',
  template: `
    <fl-table
      [dataSource]="validatedUsers"
      [edgeToEdge]="true"
      [itemsPerPage]="5"
      [mobileViewCompact]="TableMobileStyle.SIMPLE"
      [paddingSize]="TableColumnPaddingSize.SMALL"
      [paginationPosition]="TablePaginationPosition.LEFT"
    >
      <fl-table-col [columnPlacement]="ResponsiveColumnPlacement.CENTER">
        <ng-template #cell let-member>
          <fl-bit
            *ngIf="member.id === (ownerId$ | flAsync)"
            class="ContentContainer"
          >
            <fl-user-avatar
              [flMarginRight]="Margin.XSMALL"
              [size]="AvatarSize.SMALL"
              [users]="[member]"
            ></fl-user-avatar>
            <fl-username
              flTrackingLabel="userProfileLink"
              [displayName]="member.displayName"
              [link]="member.profileUrl"
              [username]="member.username"
            ></fl-username>
          </fl-bit>
          <fl-bit
            *ngIf="!(member.id === (ownerId$ | flAsync))"
            class="ContentContainer"
          >
            <fl-user-avatar
              [flMarginRight]="Margin.XSMALL"
              [size]="AvatarSize.SMALL"
              [users]="[member]"
            ></fl-user-avatar>
            <fl-text
              i18n="Payment share team modal removed member text"
              [weight]="FontWeight.LIGHT"
            >
              {{ member.displayName }} will be added to your team
            </fl-text>
          </fl-bit>
        </ng-template>
      </fl-table-col>

      <fl-table-col [columnPlacement]="ResponsiveColumnPlacement.CENTER">
        <ng-template #cell let-member>
          <fl-link
            *ngIf="!(member.id === (ownerId$ | flAsync))"
            i18n="Payment share team modal undo remove member link"
            flTrackingLabel="UndoRemoveMember"
            [flMarginBottom]="Margin.XSMALL"
            [underline]="LinkUnderline.NEVER"
            (click)="removeMember.emit(member.username)"
          >
            Undo
          </fl-link>
        </ng-template>
      </fl-table-col>
    </fl-table>
  `,
  styleUrls: ['./payment-share-add-member-table.component.scss'],
})
export class PaymentShareAddMemberTableComponent implements OnInit {
  AvatarSize = AvatarSize;
  LinkUnderline = LinkUnderline;
  FontWeight = FontWeight;
  FontType = FontType;
  Margin = Margin;
  LinkColor = LinkColor;
  TableColumnPaddingSize = TableColumnPaddingSize;
  TablePaginationPosition = TablePaginationPosition;
  ResponsiveColumnPlacement = ResponsiveColumnPlacement;
  TableMobileStyle = TableMobileStyle;

  ownerId$: Rx.Observable<Number>;

  @Input() validatedUsers: readonly User[];
  @Output() removeMember = new EventEmitter<string>();

  constructor(private auth: Auth) {}

  ngOnInit() {
    this.ownerId$ = this.auth
      .getUserId()
      .pipe(map(toNumber), filter(isDefined));
  }
}
